import { FiLoader } from 'react-icons/fi'
import styled, { keyframes } from 'styled-components'
import { pxToRem } from 'styles/functions'

const spin = keyframes`
  from {
      transform:rotate(0deg);
  }
  to {
      transform:rotate(360deg);
  }
`

export const StyledLoader = styled(FiLoader)`
  ${({ theme }) => theme.trigger_hide_loader && 'display: none'};
  margin-right: ${pxToRem(10)};
  animation: ${spin} 3s linear infinite;
`
